import clsx from 'clsx'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import PriorityBadge from '@/components/view/atoms/badge/PriorityBadge'
import Text from '@/components/view/atoms/text/Text'

const priorityStyle = (priority: 'high' | 'medium' | 'low') => {
  switch (priority) {
    case 'high':
      return {
        card: 'border-critical'
      }
    case 'medium':
      return {
        card: 'border-primitive-kaki-300',
        strip: 'bg-primitive-kaki-300'
      }
    default:
      return {
        card: 'border-primary'
      }
  }
}

interface Props {
  priority: 'high' | 'medium' | 'low'
  title: string | undefined
  badgeText?: string
  contentText?: React.ReactNode
  subContent?: React.ReactNode
}

const PriorityBar = ({ priority, title, badgeText, contentText, subContent }: Props) => {
  return (
    <div
      className={clsx(
        'bg-surface flex items-stretch overflow-hidden rounded-lg border p-1',
        priorityStyle(priority).card
      )}
    >
      <PriorityBadge priority={priority} size='big' />
      <div className='flex flex-1 justify-between gap-1 px-4 py-2'>
        {(title || badgeText || contentText) && (
          <div className='flex flex-1 flex-col justify-center gap-1'>
            <div className='flex items-center gap-2'>
              {badgeText && (
                <Badge size={12} badgeType={BadgeType.SQUARE_SECONDARY} fixed>
                  {badgeText}
                </Badge>
              )}
              {title && (
                <Text size={16} weight='bold'>
                  {title}
                </Text>
              )}
            </div>
            {contentText && <Text size={14}>{contentText}</Text>}
          </div>
        )}
        {subContent && <>{subContent}</>}
      </div>
    </div>
  )
}

export default PriorityBar
